import { render, staticRenderFns } from "./OsStatisticsCardParticipantsPerLanguage.vue?vue&type=template&id=1b9d03d3&scoped=true"
import script from "./OsStatisticsCardParticipantsPerLanguage.vue?vue&type=script&lang=ts"
export * from "./OsStatisticsCardParticipantsPerLanguage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9d03d3",
  null
  
)

export default component.exports